'use strict';

function objectMap(obj, cb) {
  return Object.keys(obj).reduce(function(result, key) {
    result[key] = cb(key, obj[key]);
    return result;
  }, {});
}

module.exports = objectMap;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@mapbox/mapbox-sdk/services/service-helpers/object-map.js
// module id = 3153
// module chunks = 0